/**
 * Constants for remuneration elements.
 *
 * Currently France-only. To add other countries later:
 * - Either key by country (e.g. REMUNERATION_CONSTANTS = { fr: { ... }, be: { ... } })
 *   and resolve at runtime from company/contract country.
 * - Or split per country (e.g. remuneration.constants.fr.ts, remuneration.constants.be.ts)
 *   and re-export from a small resolver that picks the right module from context.
 */

/**
 * Minimum wage (SMIC) value (2026).
 * Source: [Service-Public.fr](https://www.service-public.fr/particuliers/vosdroits/F2405)
 */
export const SMIC_MINIMUM = 12.31;

/**
 * Remuneration reference document (scale, collective agreement).
 * - Type for `document` table (document_type)
 * - Type for `company_document` table (company_document_type)
 */
export const REMUNERATION_REFERENCE_DOCUMENT_TYPE = "admin__company_remuneration_reference";
export const REMUNERATION_REFERENCE_COMPANY_DOCUMENT_TYPE = "remuneration_reference";

/**
 * Allowed MIME types for reference document upload.
 * Use on API (validation) and frontend (accept, validation).
 */
export const REMUNERATION_REFERENCE_ALLOWED_MIME_TYPES: string[] = ["application/pdf", "image/jpeg", "image/png"];

/** Legal overtime premium from the 36th to the 43rd hour (France). */
export const LEGAL_OVERTIME_RATE_36_TO_43_PERCENT = 25;

/** Legal overtime premium above the 43rd hour (France). */
export const LEGAL_OVERTIME_RATE_ABOVE_43_PERCENT = 50;
